import { boolean } from './boolean'
import email from './email'
import { equals } from './equals'
import { greaterThan } from './greaterThan'
import { required } from './required'

const rules = {
  required,
  equals,
  boolean,
  email,
  greaterThan,
}

export { rules }
